import { ChangeDetectionStrategy, Component } from "@angular/core";
import type { IngestionFormPreviewData } from "../../data-ingestion/admin/ingestion.admin.preview.util";
import { ModalComponent } from "../modal.component";

@Component({
    template: `
        <div class="s25-ng">
            <s25-modal-header [data]="params()"></s25-modal-header>
            <div class="modal-body">
                @if (params()?.ingestionPoint) {
                    <p class="form-help-text c-margin-bottom--single">Interactive preview — answers are not saved.</p>
                    <s25-ng-ingestion-form
                        [previewMode]="true"
                        [previewIngestionPoint]="params()!.ingestionPoint"
                        [previewFieldDefinitions]="params()!.fieldDefinitions"
                        [previewShowHideRules]="params()!.showHideRules"
                        [showHiddenFieldPlaceholders]="true"
                    />
                }
            </div>
            <div class="modal-footer"></div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalIngestionFormPreviewComponent extends ModalComponent<IngestionFormPreviewData> {}
